<template>
	<!-- 수정 팝업 -->
	<div class="editStateWrap modal-card">
		<header class="modal-card-head">
			<p class="modal-card-title">텍스트 편집</p>
		</header>
		<section class="modal-card-body">
			<!-- 텍스트 -->
			<b-field class="popTitle" label="텍스트">
				<b-input ref="textInput" class="boardInputTxt"
				expanded
				v-model="textData.text"
				:value="textData.text"
				icon-right="close-circle"
				icon-right-clickable
				@icon-right-click="textData.text=''"
			/>
			</b-field>
			<!-- 정렬 및 폰트 두깨 -->
			<b-field grouped group-multiline>
				<template v-if="$store.state.device==='mobile'">
					<b-field>
						<b-radio-button v-model="getStyle.textAlign" @click.native="emptyCheck('textAlign', 'left')" native-value="left"><b-icon icon="format-align-left"></b-icon><span v-if="$store.state.device!=='mobile'">Left</span></b-radio-button>
						<b-radio-button v-model="getStyle.textAlign" @click.native="emptyCheck('textAlign', 'left')" native-value="center"><b-icon icon="format-align-center"></b-icon><span v-if="$store.state.device!=='mobile'">Center</span></b-radio-button>
						<b-radio-button v-model="getStyle.textAlign" @click.native="emptyCheck('textAlign', 'left')" native-value="right"><b-icon icon="format-align-right"></b-icon><span v-if="$store.state.device!=='mobile'">Right</span></b-radio-button>
						<b-radio-button v-model="getStyle.textAlign" @click.native="emptyCheck('textAlign', 'left')" native-value=""><b-icon icon="format-align-justify"></b-icon><span v-if="$store.state.device!=='mobile'">None</span></b-radio-button>
					</b-field>
					<b-field>
						<b-radio-button v-model="getStyle.fontWeight" @click.native="emptyCheck('fontWeight', 'left')" native-value="bold"><b-icon icon="format-bold"></b-icon>Bold</b-radio-button>
						<b-radio-button v-model="getStyle.fontWeight" @click.native="emptyCheck('fontWeight', 'left')" native-value="normal">Normal</b-radio-button>
					</b-field>
				</template>
				<template v-else>
					<b-field>
						<b-radio-button v-model="getStyle.textAlign" @click.native="emptyCheck('textAlign', 'left')" native-value="left"><b-icon icon="format-align-left"></b-icon>Left</b-radio-button>
						<b-radio-button v-model="getStyle.textAlign" @click.native="emptyCheck('textAlign', 'left')" native-value="center"><b-icon icon="format-align-center"></b-icon>Center</b-radio-button>
						<b-radio-button v-model="getStyle.textAlign" @click.native="emptyCheck('textAlign', 'left')" native-value="right"><b-icon icon="format-align-right"></b-icon>Right</b-radio-button>
						<b-radio-button v-model="getStyle.textAlign" @click.native="emptyCheck('textAlign', 'left')" native-value=""><b-icon icon="format-align-justify"></b-icon>None</b-radio-button>
						<b-radio-button v-model="getStyle.fontWeight" @click.native="emptyCheck('fontWeight', 'left')" native-value="bold"><b-icon icon="format-bold"></b-icon>Bold</b-radio-button>
						<b-radio-button v-model="getStyle.fontWeight" @click.native="emptyCheck('fontWeight', 'left')" native-value="normal">Normal</b-radio-button>
					</b-field>
				</template>
			</b-field>
			<hr>
			<!-- Wrap 태그 -->
			<b-field class="popTitle" label="Wrap 태그"></b-field>
			<b-field grouped group-multiline>
				<b-field>
				<b-radio-button v-model="textData.tag" native-value="p">P</b-radio-button>
				<b-radio-button v-model="textData.tag" native-value="div">DIV</b-radio-button>
				<b-radio-button v-model="textData.tag" native-value="span">SPAN</b-radio-button>
				</b-field>
				<b-field>
				<b-radio-button v-model="textData.tag" native-value="h1">H1</b-radio-button>
				<b-radio-button v-model="textData.tag" native-value="h2">H2</b-radio-button>
				<b-radio-button v-model="textData.tag" native-value="h3">H3</b-radio-button>
				<b-radio-button v-model="textData.tag" native-value="h4">H4</b-radio-button>
				<b-radio-button v-model="textData.tag" native-value="h5">H5</b-radio-button>
				</b-field>
			</b-field>
			<div class="columns is-desktop">
				<div class="column">
					<!-- ID -->
					<b-field label="ID" custom-class="is-medium">
						<b-input class="boardInputTxt" v-model="textData.id" :value="textData.id" />
					</b-field>
				</div>
				<div class="column">
					<!-- 클래스 -->
					<b-field label="class" custom-class="is-medium" message="공백으로 각 항목을 구분합니다. e.g. classname1 classname2">
						<b-input v-model="textData.class" expanded :value="textData.class"/>
					</b-field>
				</div>
			</div>
			<hr>
			<!-- 스타일 -->
			<b-field label="style" custom-class="is-medium">
				<b-field grouped group-multiline>
					<b-field v-for="(styleItem, name, idx) in textData.style" :key="idx" :label="name" >
						<template v-if="name=='color'||name=='backgroundColor'">
							<ChromePicker :value="colorConvert(textData.style[name])" @input="colorConvertSet($event, textData.style, name)" />
						</template>
						<b-input v-else v-model="textData.style[name]" :value="styleItem"/>
					</b-field>
				</b-field>
			</b-field>
		</section>
		<footer class="modal-card-foot is-centered">
			<button class="button" type="button" @click="$parent.close()">확인</button>
		</footer>
	</div>
</template>

<script>
import { Chrome } from 'vue-color'
import tinycolor from 'tinycolor2'
export default {
	name: 'TextFieldEditor',
	components: {
		'ChromePicker': Chrome
	},
	props: {
		textData: {
			type: Object,
			default: function () {
				return {
					uiType: 'input',
					text: '',
					option: [
						/* {
							name: 'optionName',
							type: 'string, number, boolean, ',
							value: value
						} */
					],
					class: '', /* 'className1 className2', ... */
					style: {
						/* color: '#32320a', fontSize: '24px', padding: '20px 10px 20px 5px', margint: '0px auto 20px auto' */
					}
				}
			}
		}
	},
	computed: {
		getStyle () {
			if (this.textData.style) {
				return this.textData.style ? this.textData.style : {}
			} else {
				return {}
			}
		}
	},
	methods: {
		colorConvert (color) {
			var col
			if (typeof (color) === 'string') {
				col = tinycolor(color).toRgbString()
			} else if (typeof (color) === 'object') {
				col = tinycolor(color.rgba).toRgbString()
			}
			return col
		},
		colorConvertSet (e, obj, name) {
			if (!obj) return
			if (!name) return
			var tg = obj[name]
			var col
			if (tg) {
				col = tinycolor(e.rgba).toRgbString()
				obj[name] = col
			}
		},
		emptyCheck (styleName, value) {
			/* 스타일 객체가 없을 경우 스타일 객체 생성 */
			var obj = {}
			obj[styleName] = value
			if (!this.textData.style) {
				this.$set(this.textData, 'style', {})
				this.$set(this.textData.style, styleName, value)
			}
		}
	}
}
</script>

<style lang="scss"> // scoped
@import '@/css/variables.scss';
.icon { margin-left: 10px;}
.editStateWrap {
	padding: 20px;
	border-radius: 6px;
	border: 1px solid rgb(223, 223, 223);
	background-color: rgb(247, 247, 247);
	hr {
		border-bottom: 1px solid $c-gray-light2;
	}
	.buttons {
		border-top: 1px solid $c-gray-dark;
		padding: 20px 0 0;
		margin-top: 20px;
	}
}
.boardInputTxt {
	min-width: $mnWMobile;
}
.strech {
	align-content: stretch;
}
.popTitle { margin-top: 20px;}
.b-radio.radio {margin-right: 0;}

.withHyphen {
	.rowspan {
		position: relative;
		padding-left: 10px;
		&::before {
			display: block;
			position: absolute;
			left: 0;
			content: '-';
		}
	}
}
.modal {
	z-index: 9990;
}
.modal-card-foot {
	justify-content: flex-end;
}
.modal-close::before,
.modal-close::after {
  background-color: $c-gray;
}
.modal-close:hover::before,
.modal-close:hover::after {
  background-color: $c-white;
}
/*
	##Device = Laptops, Desktops
	##Screen = B/w 1025px to 1280px
*/
@media (min-width: 1025px) and (max-width: 1280px) {
	//CSS
}

/*
	##Device = Tablets, Ipads (portrait)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) {
	//CSS
}

/*
	##Device = Tablets, Ipads (landscape)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  //CSS
}

/*
	##Device = Low Resolution Tablets, Mobiles (Landscape)
	##Screen = B/w 481px to 767px
*/
@media (min-width: 650px) and (max-width: 767px) {
	//css
}

/*
	##Device = Most of the Smartphones Mobiles (Portrait)
	##Screen = B/w 320px to 479px
*/
@media (min-width: $mnWMobile) and (max-width: 480px) {
	//CSS
}
</style>
